'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
require('./IconNavigation.css');
var _Icon = require('../Icon/Icon');
var _Icon2 = _interopRequireDefault(_Icon);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * Item within an Icon Navigation.
 *
 * See also Icon Navigation
 */
var IconNavigationItem = function IconNavigationItem(_ref) {
  var iconType = _ref.iconType,
    children = _ref.children,
    href = _ref.href,
    onClick = _ref.onClick,
    selected = _ref.selected;
  var classes = (0, _classnames2.default)('c-navigation-icons__item', {
    'c-navigation-icons__item--active': selected
  });
  return _react2.default.createElement('a', {
    className: classes,
    href: href,
    onClick: onClick
  }, _react2.default.createElement(_Icon2.default, {
    type: iconType
  }), children);
};
IconNavigationItem.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Icon to display*/
  iconType: _propTypes2.default.string.isRequired,
  /** Link to go to when the user clicks the navigation item*/
  href: _propTypes2.default.string,
  /** onClick event function*/
  onClick: _propTypes2.default.func,
  /** Whether the icon should be rendered in its selected state*/
  selected: _propTypes2.default.bool,
  /** Text to display as child*/
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
} : {};
exports.default = IconNavigationItem;